var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7983 0.046875C4.8736 0.046875 0.0473633 4.8731 0.0473633 10.7979C0.0473633 16.7226 4.8736 21.5582 10.7983 21.5582C13.329 21.5582 15.6564 20.6714 17.4958 19.1989L21.974 23.6747C22.2 23.8914 22.5019 24.0109 22.8149 24.0077C23.1279 24.0045 23.4273 23.8789 23.6488 23.6576C23.8703 23.4364 23.9964 23.1373 24 22.8243C24.0036 22.5113 23.8845 22.2092 23.6682 21.983L19.19 17.5048C20.6637 15.6625 21.5516 13.3314 21.5516 10.7979C21.5516 4.8731 16.7231 0.046875 10.7983 0.046875ZM10.7983 2.43653C15.4316 2.43653 19.1597 6.16458 19.1597 10.7979C19.1597 15.4311 15.4316 19.1686 10.7983 19.1686C6.16505 19.1686 2.43699 15.4311 2.43699 10.7979C2.43699 6.16458 6.16505 2.43653 10.7983 2.43653Z",
    fill: "#00726B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.fdce8c0fa1d17f52f9dfbc0d353928bf.svg";
export { ForwardRef as ReactComponent };